webpackJsonp([72],{

/***/ "Q8Cs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MainLanding = (function () {
    MainLanding.$inject = ["analyticSvc"];
    function MainLanding(analyticSvc) {
        this.analyticSvc = analyticSvc;
    }
    MainLanding.prototype.selectProduct = function (product) {
        this.analyticSvc.selectProduct(product);
    };
    return MainLanding;
}());
exports.MainLanding = MainLanding;
angular.module('animatronApp.mainLanding', []).component('mainLanding', {
    controller: MainLanding,
    templateUrl: __webpack_require__("rVl+")
});


/***/ }),

/***/ "rVl+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/main-landing_a49b678577cbc33a7f42aa9b5e9ab57b.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/72-bd880478516a225297ea.min.js